import { render, staticRenderFns } from "./QuantitySelector.vue?vue&type=template&id=1fb2c990&scoped=true"
import script from "./QuantitySelector.vue?vue&type=script&lang=js"
export * from "./QuantitySelector.vue?vue&type=script&lang=js"
import style0 from "./QuantitySelector.vue?vue&type=style&index=0&id=1fb2c990&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fb2c990",
  null
  
)

/* custom blocks */
import block0 from "./translations?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fdata%2Fwww%2Fsrc%2Fcomponents%2F01-atoms%2Fquantity-selector%2FQuantitySelector.vue&external"
if (typeof block0 === 'function') block0(component)

export default component.exports